module.exports = __webpack_public_path__ + "img/chengdujiaozi.e2de2b31.png";